import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import onboardingPlaceholder from '../../images/onboarding-video-placeholder.png';

const OnboardingSection = ({ onDismiss, isQuickOnboardingMode = false }) => {
  const [isWatchMode, setIsWatchMode] = useState(false);

  // Video Configuration - you can update this with your actual onboarding video ID
  const videoId = "gdAUZPOdd7M"; // Update with your actual video ID
  const watchParams = "autoplay=1&mute=0&controls=1&showinfo=0&rel=0&modestbranding=1";

  return (
    <div className={" bg-white  border-[#E0E4E2] rounded-2xl overflow-hidden " + (isQuickOnboardingMode ? "" : "border")}>
      <div className={`${isQuickOnboardingMode ? "" : "p-6"}`}>
        {/* Header Section */}
        {isQuickOnboardingMode ||
          <div className="mb-4">
            <h2 className="text-2xl font-black text-[#1D2129] leading-[1.17em] mb-1">
              Quick Onboarding : Start integrating Our API
            </h2>
            <p className="text-sm font-medium text-[#1D2129] leading-[2em]">
              Watch this 2-minute video to get started quickly
            </p>
          </div>
        }
        {/* Video Section */}
        <div className="relative w-full h-[440px] rounded-xl overflow-hidden group">
          {/* Dismiss Icon on Image */}
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="absolute top-4 right-4 p-2 hover:bg-black/40 text-white/80 hover:text-white rounded-full transition-all duration-200 z-50 backdrop-blur-sm"
              aria-label="Dismiss onboarding"
            >
              <X size={20} />
            </button>
          )}

          {/* Background Content */}
          <div className={`absolute inset-0 z-0 transition-all duration-700`}>
            {isWatchMode ? (
              <iframe
                className="w-full h-full object-cover"
                src={`https://www.youtube.com/embed/${videoId}?${watchParams}`}
                title="NKENNEAI Onboarding Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                frameBorder="0"
              ></iframe>
            ) : (
              <img
                src={onboardingPlaceholder}
                alt="Onboarding Preview"
                className="w-full h-full object-cover"
              />
            )}

            {/* Gradient Overlay */}
            {!isWatchMode && (
              <div className="absolute inset-0"></div>
            )}
          </div>

          {/* Close Button for Watch Mode */}
          {isWatchMode && (
            <button
              onClick={() => setIsWatchMode(false)}
              className="absolute top-4 right-4 z-50 bg-white/10 hover:bg-white/20 backdrop-blur-md p-2 rounded-full text-white transition-all duration-300 transform hover:scale-110"
            >
              <X size={20} />
            </button>
          )}

          {/* Play Button Overlay */}
          {!isWatchMode && (
            <div className="absolute inset-0 z-10 flex items-center justify-center">
              <button
                onClick={() => setIsWatchMode(true)}
                className="bg-[#F5C956] hover:bg-[#E5B946] rounded-full p-6 transition-all duration-300 transform hover:scale-110 shadow-lg"
              >
                <Play size={28} fill="#000000" className="text-black ml-1" />
              </button>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default OnboardingSection;

